<template>
    <component
        v-if="route.name !== 'Course'"
        :is="childComponents[route.name]"
    />
    <div v-else class="py-10">
        <LoadingState
            v-if="loadingCourse"
            :loading="loadingCourse"
            class="absolute top-5 left-1/2 -translate-x-1/2 z-20"
            :noBackground="true"
        />

        <div v-else class="flex flex-col pt-4 relative max-w-5xl mx-auto">
            <div class="flex-1 transition-all">
                <header class="mb-8 px-3 flex">
                    <div>
                        <h3
                            class="text-slate-800 font-bold text-2xl lg:text-3xl xl:text-4xl leading-10"
                        >
                            {{ course.title }}
                        </h3>
                        <div
                            class="pt-4 prose text-slate-500"
                            v-html="course.description"
                        ></div>
                    </div>
                    <!-- Orange travel graphic: -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="88"
                        height="88"
                        fill="none"
                    >
                        <path
                            fill="url(#a)"
                            fill-rule="evenodd"
                            d="M38.513 1.998A17.151 17.151 0 0 0 20.78 13.311a5.773 5.773 0 0 0 3.946 7.615l16.345 5.26c.56.199.99.654 1.156 1.224l2.592 8.887a3.763 3.763 0 0 0 2.497 2.594l.007.002 7.401 2.383.003.001a3.826 3.826 0 0 0 4.947-4.31L58.49 31.27l14.704 4.786a5.711 5.711 0 0 0 7.245-3.536l5.463-16.814c.129-.393.38-1.164.226-2a3.637 3.637 0 0 0-2.295-2.744l-6.286-2.137a3.638 3.638 0 0 0-4.173 1.39l-.005.008a2.224 2.224 0 0 0-.016.025l-1.025 1.586a5.833 5.833 0 0 1-7.508 2.052L45.596 4.274a17.151 17.151 0 0 0-7.083-2.276Zm3.526 21.349-.49 1.417.46-1.428-16.407-5.28a1.504 1.504 0 0 0-.093-.026 2.774 2.774 0 0 1-1.917-3.672l.01-.028a14.152 14.152 0 0 1 20.516-7.445c.03.018.06.034.091.05l19.268 9.633a8.833 8.833 0 0 0 11.37-3.107l1.01-1.564a.637.637 0 0 1 .723-.233l6.235 2.12a.638.638 0 0 1 .361.461c0 .007.002.04-.012.117a3.8 3.8 0 0 1-.13.457l-5.442 16.753a2.711 2.711 0 0 1-3.434 1.643l-.025-.009-15.912-5.179a2.27 2.27 0 0 0-2.925 2.62l1.432 6.888a.825.825 0 0 1-1.075.889l-7.422-2.39-.011-.004a.762.762 0 0 1-.508-.53l-.003-.008-.006-.022-2.596-8.9a4.847 4.847 0 0 0-3.068-3.223Z"
                            clip-rule="evenodd"
                        />
                        <path
                            fill="url(#b)"
                            fill-rule="evenodd"
                            d="M34.54 42.45a1.5 1.5 0 0 0-2.702-1.304 11.558 11.558 0 0 0-.332 9.296l.006.016a11.054 11.054 0 0 0 10.292 6.858 3.34 3.34 0 0 1 3.336 3.34V81.42a29.93 29.93 0 0 1-18.497.859V67.948a11.182 11.182 0 0 0-11.45-11.181H4.83a29.928 29.928 0 0 1 10.287-26.09 1.5 1.5 0 0 0-1.95-2.28 32.928 32.928 0 0 0 33.776 55.54c.19-.04.366-.115.522-.218A32.92 32.92 0 0 0 63.46 69.226 32.93 32.93 0 0 0 67.5 53.423a1.5 1.5 0 0 0-3 0 29.929 29.929 0 0 1-16.36 26.674V60.656a6.34 6.34 0 0 0-6.34-6.34h-.01a8.055 8.055 0 0 1-7.5-4.99 8.559 8.559 0 0 1 .25-6.875ZM5.323 59.768a29.93 29.93 0 0 0 18.319 21.515V67.947a8.184 8.184 0 0 0-5.197-7.62 8.182 8.182 0 0 0-3.235-.56H5.324Z"
                            clip-rule="evenodd"
                        />
                        <defs>
                            <radialGradient
                                id="a"
                                cx="0"
                                cy="0"
                                r="1"
                                gradientTransform="matrix(12.99999 68 -113.48673 21.69597 33 28)"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FD421D" />
                                <stop offset="1" stop-color="#FAB34A" />
                            </radialGradient>
                            <radialGradient
                                id="b"
                                cx="0"
                                cy="0"
                                r="1"
                                gradientTransform="matrix(12.99999 68 -113.48673 21.69597 33 28)"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FD421D" />
                                <stop offset="1" stop-color="#FAB34A" />
                            </radialGradient>
                        </defs>
                    </svg>
                </header>

                <div class="mb-16 px-3">
                    <ProgressBar class="mb-5" />
                    <StartNextChapter />
                </div>

                <h4 class="text-slate-800 text-lg font-medium mb-8 px-3">
                    Course Lessons
                </h4>

                <ChapterList />
            </div>
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { onMounted, onUnmounted } from 'vue';
import { useCoursesStore } from '@/store/courses';
import Chapter from '@/components/courses/chapter.vue';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';
import ProgressBar from '@/components/courses/progress-bar.vue';
import StartNextChapter from '@/components/courses/start-next-chapter.vue';
import ChapterList from '@/components/courses/chapter-list/list.vue';

const store = useCoursesStore();
const scriptSrc = 'https://app.wonderchat.io/scripts/wonderchat.js';
const scriptId = 'wonderchat-script';
const route = useRoute();
const { course, loadingCourse } = storeToRefs(store);

const childComponents = {
    Chapter,
};

onMounted(() => {
    store.getCourse(route.params.slug).then(() => {
        //
    });

    if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.src = scriptSrc;
        script.id = scriptId;
        script.setAttribute('data-name', 'wonderchat');
        script.setAttribute('data-address', 'app.wonderchat.io');
        script.setAttribute('data-id', 'cm37rcup2012n204tgw2bx0al');
        script.setAttribute('data-widget-size', 'normal');
        script.setAttribute('data-widget-button-size', 'normal');
        script.defer = true;

        document.body.appendChild(script);
    }
});

onUnmounted(() => {
    const script = document.getElementById(scriptId);
    if (script) {
        script.remove();
    }
});
</script>
